The page of candidate process history items and their corresponding cursors.

This list may be empty.
